import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CheckAccess } from '../../cloud.service';
import { ErrorsService } from '@core/services/errors.service';
import { PassportService } from '../../../auth/passport.service';
import { environment } from '../../../../environments/environment';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as consumersState from '../store/reducers/consumers.reducer';
import * as consumersActions from '../store/actions/consumers.actions';
import { MatDialog } from '@angular/material/dialog';

/**
 * @deprecated will be deleted
 */

// DELETE when all module will be ready

@Injectable({
    providedIn: 'root'
})
export class ConsumersService {
    _baseURL: string;
    public headers = new HttpHeaders();
    token: string;

    constructor(
        private httpClient: HttpClient,
        private auth: PassportService,
        public _checkAccess: CheckAccess,
        private errors: ErrorsService
    ) {
        this._baseURL = environment.baseURL;
    }

    getConsumers(page, perPage, search_string = null) {
        if (this._checkAccess.listAccess('read', 6)) {
            this.headers = new HttpHeaders();
            this.headers = this.headers.append('Authorization', 'Bearer ' + this.auth.token);
            this.headers = this.headers.append('Access-Control-Allow-Origin', '*');
            if (page === null && perPage === null) {
                return this.httpClient.post(this._baseURL + 'reference/consumer/list', { paginate: false }, { headers: this.headers }).pipe(
                    map((result: any) => {
                        return result.data.consumers;
                    })
                );
            } else {
                const reqData = { paginate: true, page: page, per_page: perPage };
                if (search_string) {
                    reqData['search'] = search_string;
                }
                return this.httpClient.post(this._baseURL + 'reference/consumer/list', { ...reqData }, { headers: this.headers }).pipe(
                    map((result: any) => {
                        return result.data.consumers;
                    })
                );
            }
        } else {
            // this.errors.showSnackbar('msg_95', true);
        }
    }

    addConsumer(data) {
        if (this._checkAccess.listAccess('create', 6)) {
            this.headers = new HttpHeaders();
            this.headers = this.headers.append('Authorization', 'Bearer ' + this.auth.token);
            this.headers = this.headers.append('Access-Control-Allow-Origin', '*');
            return this.httpClient
                .post(this._baseURL + 'reference/consumer/create', data, {
                    headers: this.headers
                })
                .pipe(
                    map((result: any) => {
                        return result.msg;
                    })
                );
        } else {
            this.errors.showSnackbar('msg_96', true);
        }
    }

    editConsumer(data) {
        if (this._checkAccess.listAccess('update', 6)) {
            this.headers = new HttpHeaders();
            this.headers = this.headers.append('Authorization', 'Bearer ' + this.auth.token);
            this.headers = this.headers.append('Access-Control-Allow-Origin', '*');
            return this.httpClient
                .put(this._baseURL + `reference/consumer/update`, data, {
                    headers: this.headers
                })
                .pipe(
                    map((result: any) => {
                        return result.msg;
                    })
                );
        } else {
            this.errors.showSnackbar('msg_97', true);
        }
    }

    deleteConsumer(consumerId) {
        if (this._checkAccess.listAccess('delete', 6)) {
            this.headers = new HttpHeaders();
            this.headers = this.headers.append('Authorization', 'Bearer ' + this.auth.token);
            this.headers = this.headers.append('Access-Control-Allow-Origin', '*');
            return this.httpClient
                .delete(this._baseURL + `reference/consumer/${consumerId}`, {
                    headers: this.headers
                })
                .pipe(
                    map((result: any) => {
                        return result.msg;
                    })
                );
        } else {
            this.errors.showSnackbar('msg_98', true);
        }
    }

    getConsumer(id) {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Authorization', 'Bearer ' + this.auth.token);
        this.headers = this.headers.append('Access-Control-Allow-Origin', '*');
        return this.httpClient.get<any>(`${this._baseURL}reference/consumer/${id}`, { headers: this.headers });
    }
}
@Injectable({
    providedIn: 'root'
})
export class ConsumersStateService {
    constructor(
        private error: ErrorsService,
        private store: Store<consumersState.ConsumersState>,
        private dialog: MatDialog
    ) {}

    public addConsumerSuccess(page, perPage, msg) {
        //this.store.dispatch();
        this.dialog.closeAll();
        this.error.showSnackbar(msg);
        return new consumersActions.fetchConsumers({ page, perPage });
    }

    public addConsumerFail(error: any) {
        this.error.showSnackbar(error.error?.error?.data?.msg ? error.error.error.data.msg : error.error?.error?.msg);
        return new consumersActions.addConsumersFail(error.error.error);
    }

    public editConsumerSuccess(page, perPage, msg) {
        //this.store.dispatch();
        this.dialog.closeAll();
        this.error.showSnackbar(msg);
        return new consumersActions.fetchConsumers({ page, perPage });
    }

    public editConsumerFail(error: any) {
        this.error.showSnackbar(error.error?.error?.data?.msg ? error.error.error.data.msg : error.error?.error?.msg);
        return new consumersActions.addConsumersFail(error.error.error);
    }
}
